import { UUID } from '@cmg/common';
import { SelectOption } from '@cmg/design-system';

import {
  AllocationAcknowledgement,
  IndicationStatus,
  InstitutionalIndicationOrderType,
  MdlAllocationRanking,
} from '../../../../../../graphql';

export type IndicationType = {
  id: UUID;
  offeringId: UUID;
  type: InstitutionalIndicationOrderType;
  status: IndicationStatus;
  allocationVersion?: string | null;
  allocationShares?: number | null;
  investorReplyStatus?: AllocationAcknowledgement | null;
};

export const rankingLabels = {
  [MdlAllocationRanking.Top_5]: 'Top 5',
  [MdlAllocationRanking.Top_10]: 'Top 10',
  [MdlAllocationRanking.Top_15]: 'Top 15',
  [MdlAllocationRanking.Top_25]: 'Top 25',
  [MdlAllocationRanking.Top_50]: 'Top 50',
  [MdlAllocationRanking.Over_50]: 'Over 50',
  [MdlAllocationRanking.NotIndicated]: 'Not Indicated',
} as const;

export const getRankingOptions = (): SelectOption<MdlAllocationRanking>[] => {
  return [
    MdlAllocationRanking.Top_5,
    MdlAllocationRanking.Top_10,
    MdlAllocationRanking.Top_15,
    MdlAllocationRanking.Top_25,
    MdlAllocationRanking.Top_50,
    MdlAllocationRanking.Over_50,
    MdlAllocationRanking.NotIndicated,
  ].map(rank => ({ value: rank, label: rankingLabels[rank] }));
};

export type AllocationDetailsDataType = Readonly<{
  shareQuantity: number | null;
  offerPrice: number;
  pricingCurrencyCode: string;
  orderType: InstitutionalIndicationOrderType | null;
  indicationStatus: IndicationStatus | null;
  isOrderBookOpen: boolean;
  investorReplyStatus: AllocationAcknowledgement;
  sellingConcession?: number;
  tradeDate?: string;
  settlementDate?: string;
}>;
